import type { CityConfig } from "../city-template/types";

export const napervilleConfig: CityConfig = {
  city: "Naperville",
  state: "Illinois",
  stateAbbr: "IL",
  slug: "naperville",
  route: "/naperville",
  title: "Emergency Passport Naperville, IL — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Naperville, Illinois — as fast as 24 hours. Fast passport renewal and new passport applications for Naperville, Warrenville, Lisle, Wheaton, and all DuPage County residents. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Naperville, IL",
  heroSubtitle: "Naperville travelers — from Edward Hospital physicians to downtown corporate professionals to DuPage County families — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving all of Naperville and the western Chicago suburbs.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Beautiful%20suburban%20downtown%20Naperville%20Illinois%20along%20the%20Riverwalk%20with%20the%20Millennium%20Carillon%20tower%2C%20modern%20brick%20buildings%20mixed%20with%20historic%20architecture%2C%20DuPage%20River%20flowing%20through%20the%20scene%2C%20lush%20green%20trees%2C%20warm%20golden%20afternoon%20sunlight%2C%20affluent%20Chicago%20suburb%20atmosphere%2C%20professional%20city%20photography%20without%20text%20or%20people%2C%20clean%20and%20vibrant%20small%20city%20aesthetic&width=1800&height=700&seq=naperville-hero-001&orientation=landscape",
  heroImageAlt: "Naperville Illinois downtown Riverwalk with the Millennium Carillon and DuPage River",
  geoPosition: "41.7508;-88.1535",
  geoPlacename: "Naperville, Illinois",
  lastModified: "2026-06-02",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 35 minutes northeast of Naperville via I-88 and I-290",
  },
  nearbyCitiesZips: [
    { name: "Naperville", zips: "60540, 60563, 60564, 60565" },
    { name: "Warrenville", zips: "60555" },
    { name: "Lisle", zips: "60532" },
    { name: "Wheaton", zips: "60187, 60189" },
    { name: "Aurora", zips: "60502, 60503, 60504, 60505, 60506, 60507" },
    { name: "Bolingbrook", zips: "60440, 60490" },
    { name: "Plainfield", zips: "60544, 60585, 60586" },
    { name: "Oswego", zips: "60543" },
    { name: "Downers Grove", zips: "60515, 60516" },
    { name: "Glen Ellyn", zips: "60137, 60138" },
    { name: "Carol Stream", zips: "60188, 60116, 60132, 60197" },
    { name: "Woodridge", zips: "60517" },
    { name: "Darien", zips: "60561" },
    { name: "Westmont", zips: "60559" },
    { name: "Hinsdale", zips: "60521, 60522" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to Chicago Passport Agency — no 35-minute drive required" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-building-line", title: "Corporate Travel Hub", desc: "Serving Edward Hospital, Nokia, BP America, and downtown Naperville businesses" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — no trip to downtown Chicago required" },
  ],
  internalLinks: [
    { name: "Expedited passport in Aurora, IL", route: "/aurora" },
    { name: "Emergency passport help in Wheaton, IL", route: "/illinois" },
    { name: "Urgent passport services in Rockford, IL", route: "/rockford" },
    { name: "Illinois passport services overview", route: "/illinois" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Naperville, Illinois remotely via secure registered courier. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (35 minutes northeast via I-88) — without you making the trip. Naperville residents can ship from any UPS or FedEx in DuPage County.",
  fpcOfficeDistance: "Serving Naperville, Warrenville, Lisle, Wheaton, Aurora, Bolingbrook, Plainfield, Oswego, Downers Grove, Glen Ellyn, Carol Stream, Woodridge, Darien, Westmont, Hinsdale, and all of DuPage County",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Naperville and the western Chicago suburbs. From downtown Naperville along the Riverwalk to the Edward Hospital medical corridor, from the corporate offices along Diehl Road to the family neighborhoods of south Naperville — we serve all of DuPage County and beyond.",
  nearbyCitiesIntro: "We serve Naperville and all nearby communities including Warrenville, Lisle, Wheaton, Aurora, Bolingbrook, Plainfield, Oswego, Downers Grove, Glen Ellyn, Carol Stream, Woodridge, Darien, Westmont, and Hinsdale. We also serve Kane County, Will County, and all western Chicago suburban communities.",
  howItWorksIntro: "Most Naperville travelers complete everything online and ship documents overnight. No need to drive 35 minutes to downtown Chicago — our couriers handle the Chicago Passport Agency trip for you.",
  mistakesIntro: "Naperville is one of the most affluent suburbs in the Midwest with significant corporate travel and high-income family international vacations. Here are the most common passport mistakes we see from DuPage County travelers.",
  testimonialsIntro: "Naperville travelers — from Edward Hospital physicians to corporate professionals to DuPage County families — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Naperville, IL? Here are the most common ones we hear from western Chicago suburban travelers.",
  statePageRoute: "/states/illinois",
  statePageName: "Illinois",
  dmvWebsite: "https://www.ilsos.gov/facilities/facilitylist.html",
  dmvLabel: "Illinois Secretary of State — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — hand-delivered", "No drive to downtown Chicago required", "Perfect for corporate travel and family vacation deadlines", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — hand-delivered", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive 35 minutes to downtown Chicago", "Full day commitment — parking and downtown navigation"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Naperville travelers with immediate departure needs — as fast as 24 hours. Our couriers use the Chicago Passport Agency — 35 minutes away but you never make the trip.",
      bullets: ["24–48 hour turnaround available", "Chicago Passport Agency direct courier", "DuPage County corporate and family travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Naperville adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Naperville address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Naperville residents and families — including Edward Hospital staff, new citizens, and DuPage County families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Naperville residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Naperville and DuPage County families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Naperville and DuPage County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Naperville IL", description: "Urgent passport processing for Naperville Illinois travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Naperville IL", description: "Fast passport renewal for Naperville Illinois residents with a previously-issued passport." },
    { name: "First-Time Passport Naperville IL", description: "New passport application services for Naperville Illinois residents applying for their first passport." },
    { name: "Child Passport Naperville IL", description: "Minor passport services for Naperville Illinois families with children under 16." },
  ],
  testimonials: [
    {
      name: "Dr. Jennifer M.",
      location: "Naperville, IL",
      rating: 5,
      text: "Medical conference in Geneva in 4 days and my passport expired. Fast Passport Center had my renewed passport in 2 days. I shipped from the UPS Store on Ogden Avenue and the whole process was seamless. Cannot recommend enough.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Robert K.",
      location: "Warrenville, IL",
      rating: 5,
      text: "Family cruise to the Caribbean with 7 days notice. Four passports — two adult renewals and two first-time for our kids. Done in 4 days. We shipped from FedEx on Diehl Road and everything was perfect.",
      service: "Family Passport Bundle",
    },
    {
      name: "Lisa T.",
      location: "Naperville, IL",
      rating: 5,
      text: "Business trip to London with 9 days notice. Fast Passport Center walked me through every step and had my passport in 3 days. The courier service is a game-changer for Naperville professionals.",
      service: "Emergency Passport",
    },
    {
      name: "David H.",
      location: "Lisle, IL",
      rating: 5,
      text: "Lost my passport the week before our honeymoon in Italy. Fast Passport Center replaced it in 48 hours. As someone who works in downtown Naperville, I couldn't take a day off to go to Chicago. They saved our trip.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "nap-1",
      name: "Naperville Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1750 W Ogden Ave",
      city: "Naperville",
      state: "IL",
      zip: "60540",
      phone: "(630) 420-0533",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Central Naperville, near Ogden Avenue corridor",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Naperville acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient to downtown Naperville and Edward Hospital.",
      icon: "ri-mail-line",
    },
    {
      id: "nap-2",
      name: "Wheaton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "201 W Wesley St",
      city: "Wheaton",
      state: "IL",
      zip: "60187",
      phone: "(630) 668-5661",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Wheaton, approximately 8 miles north of Naperville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Wheaton, Glen Ellyn, and northern Naperville residents. Near Wheaton College campus.",
      icon: "ri-mail-line",
    },
    {
      id: "nap-3",
      name: "Aurora Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "525 N Broadway",
      city: "Aurora",
      state: "IL",
      zip: "60505",
      phone: "(630) 897-5766",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Aurora, approximately 10 miles west of Naperville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Aurora, Montgomery, and western DuPage County. Good alternative for west-side travelers.",
      icon: "ri-mail-line",
    },
    {
      id: "nap-4",
      name: "Downers Grove Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2222 75th St",
      city: "Downers Grove",
      state: "IL",
      zip: "60516",
      phone: "(630) 968-4221",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downers Grove, approximately 12 miles northeast of Naperville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Downers Grove, Lisle, and eastern Naperville residents.",
      icon: "ri-mail-line",
    },
    {
      id: "nap-5",
      name: "DuPage County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "421 N County Farm Rd",
      city: "Wheaton",
      state: "IL",
      zip: "60187",
      phone: "(630) 407-5500",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Wheaton, DuPage County Government Complex",
      website: "https://www.dupageco.org/",
      websiteLabel: "DuPage County",
      notes: "DuPage County Clerk passport acceptance. Extended hours compared to post office locations. Call to confirm current passport acceptance hours.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 35 min drive to downtown Chicago", fpc: "No — ship from Naperville" },
    { feature: "Parking & Navigation", agency: "Downtown Chicago parking costs", fpc: "Ship from your neighborhood" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Naperville corporate professionals and families often discover passport issues just before departure. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo services near Ogden Avenue or Route 59 sometimes produce photos that meet ID requirements but fail passport standards. Photos must be exactly 2x2 inches on a white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 rejection reasons at DuPage County acceptance facilities.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking Acceptance Facilities Early Enough",
      description: "Naperville Post Office appointments fill during summer travel season and school break periods. Book 2–3 weeks ahead.",
    },
    {
      icon: "ri-road-map-line",
      title: "Underestimating the Trip to Chicago",
      description: "Many Naperville residents attempt to drive to the Chicago Passport Agency in an emergency. The 35-minute drive plus downtown parking and navigation means a half-day lost — our courier service is faster and more reliable.",
    },
    {
      icon: "ri-time-line",
      title: "Assuming 4–6 Weeks Is Enough",
      description: "Routine processing takes 6–13 weeks. If your travel is within 10 weeks, use expedited service. Spring break and summer travel from DuPage County peaks March–August — plan ahead.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in the Naperville area or DuPage County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx near Ogden Avenue or downtown Naperville." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to the Chicago Passport Agency — just 35 minutes away but you never make the trip." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Naperville address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Naperville, IL?", a: "Fast Passport Center offers emergency passport processing in Naperville, Illinois in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (35 minutes northeast via I-88) — without you making the trip." },
    { q: "Does Naperville have its own passport agency?", a: "No — Naperville does not have a regional passport agency. The nearest facility is the Chicago Passport Agency (approximately 35 minutes northeast via I-88 and I-290). Fast Passport Center's courier service means Naperville residents never need to make the trip." },
    { q: "Can I get an expedited passport in Wheaton, Lisle, or Warrenville?", a: "Absolutely. Fast Passport Center serves all of the western Chicago suburbs including Wheaton, Lisle, Warrenville, Aurora, Bolingbrook, Plainfield, Downers Grove, Glen Ellyn, and all of DuPage County. Our service works the same way everywhere." },
    { q: "What airport do Naperville travelers use for international flights?", a: "Chicago O'Hare International Airport (ORD) is the primary airport for Naperville and DuPage County travelers. O'Hare is approximately 35 minutes northeast via I-88 and I-290 and offers direct international flights worldwide. Chicago Midway (MDW) is also an option for domestic connections. Always verify passport validity for at least 6 months past your return date." },
    { q: "How much does an expedited passport cost in Naperville, IL?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Naperville?", a: "Walgreens, CVS, and UPS Store locations throughout Naperville and Warrenville offer passport photos. FedEx Office locations also provide them. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve Edward Hospital and downtown Naperville businesses?", a: "Yes. Fast Passport Center serves all of DuPage County including Edward Hospital physicians, staff, and downtown Naperville corporate professionals. We understand corporate travel schedules and medical conference deadlines. Our courier service is especially valuable for professionals who can't take a day off to go to Chicago." },
    { q: "Can I get a passport for my child in Naperville?", a: "Yes. Fast Passport Center provides child passport services for minors under 16 throughout Naperville and DuPage County. Both parents or legal guardians must typically be present at the acceptance facility, and we guide you through the entire process." },
  ],
  photoLocations: [
    { name: "Walgreens — Naperville Ogden", address: "1550 W Ogden Ave, Naperville, IL 60540", hours: "Mon–Sun: 7AM–10PM" },
    { name: "UPS Store — Naperville", address: "1220 Iroquois Ave, Naperville, IL 60563", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "CVS — Naperville Route 59", address: "1567 N Route 59, Naperville, IL 60563", hours: "Mon–Sun: 8AM–10PM" },
    { name: "FedEx Office — Naperville", address: "1295 E Ogden Ave, Naperville, IL 60563", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    { name: "Illinois SOS — Naperville", address: "931 W 75th St, Naperville, IL 60565", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Illinois Secretary of State for driver's licenses, REAL ID, and vehicle registration. Online reservations strongly recommended.", featured: true },
    { name: "Illinois SOS — Wheaton", address: "128 E Liberty Dr, Wheaton, IL 60187", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Serves Wheaton, Glen Ellyn, and northern Naperville area. Full REAL ID processing available.", featured: false },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates (IDPH)", url: "https://dph.illinois.gov/topics-services/birth-death-other-records.html", desc: "Illinois Department of Public Health — Division of Vital Records for DuPage County birth and death certificates" },
    { label: "Marriage Licenses (DuPage County Clerk)", url: "https://www.dupagecounty.gov/government/departments/county_clerk/", desc: "DuPage County Clerk — marriage license applications and certified copies for Naperville and surrounding suburbs" },
    { label: "Divorce Decrees (DuPage County Circuit Clerk)", url: "https://www.dupagecounty.gov/government/departments/circuit_court_clerk/", desc: "DuPage County Circuit Clerk — divorce decree records for Naperville and DuPage County residents" },
    { label: "VitalChek Online Ordering", url: "https://www.vitalchek.com/", desc: "Order Illinois birth, death, marriage, and divorce certificates online via VitalChek — fastest state-approved method" },
  ],
  airports: [
    {
      code: "ORD",
      name: "Chicago O'Hare International Airport",
      distance: "Approximately 35 minutes northeast via I-88 and I-290",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "Primary international airport for Naperville and DuPage County. One of the world's busiest airports with direct flights to Europe, Asia, and the Americas. United and American Airlines hub.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "ORD Flight Info",
      featured: true,
    },
    {
      code: "MDW",
      name: "Chicago Midway International Airport",
      distance: "Approximately 45 minutes east via I-88 and I-55",
      address: "5700 S Cicero Ave, Chicago, IL 60638",
      note: "Southwest Airlines hub with domestic connections. Good for travelers flying Southwest to connect to international destinations.",
      flightUrl: "https://www.flychicago.com/midway/",
      flightLabel: "MDW Flight Info",
      featured: false,
    },
    {
      code: "DPA",
      name: "DuPage Airport",
      distance: "Approximately 15 minutes north of Naperville via IL-53",
      address: "2700 International Dr, West Chicago, IL 60185",
      note: "Regional general aviation airport. Not a commercial hub, but used for private and charter flights.",
      flightUrl: "https://www.dupageairport.com/",
      flightLabel: "DPA Info",
      featured: false,
    },
  ],
};